import { useState } from 'react'
import { useNavigate } from 'react-router'
import { ChevronRight } from '@mui/icons-material'
import { Button, Grid, Typography } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from 'yup'

import FindOrderNumberDrawer from '../../../components/find-order-number-drawer'
import FormikTextField from '../../../components/formik-input'
import { useHspPlusContext } from '../../../providers/hsp-plus-provider'
import useIsMobile from '../../../utils/hooks/useIsMobile'

import useStyles from './index.styles'

const validationSchema = Yup.object({
  orderNumber: Yup.number().typeError('Order Number must be a number').required('Order Number is required'),
  lastName: Yup.string().trim().required('Last Name is required'),
  zipCode: Yup.number().typeError('Enter a valid Zip Code').required('Zip Code is required'),
})

const HSPRegistration = () => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const classes = useStyles
  const [isOrderHelpOpen, setIsOrderHelpOpen] = useState(false)
  const { values, setValues } = useHspPlusContext()

  return (
    <Formik
      initialValues={{ orderNumber: values.orderNumber, lastName: values.lastName, zipCode: values.zipCode }}
      enableReinitialize={true}
      onSubmit={(formValues) => {
        setValues(formValues)
        navigate('/hsp-plus/contact-information')
      }}
      validationSchema={validationSchema}
      validateOnMount={true}
    >
      {({ handleSubmit, isSubmitting, isValid }) => (
        <Grid container={true} component="form" onSubmit={handleSubmit} sx={classes.screen(isMobile)}>
          <Grid container={true} sx={classes.form}>
            <Grid container={true} sx={classes.intro(isMobile)}>
              <Typography component="h1" variant="h5" color="textSecondary" sx={classes.title}>
                Welcome,
                <br />
                let’s get you set up!
              </Typography>
              <Typography variant="body2">Let's find your account and complete registration</Typography>
            </Grid>

            <Grid container={true} sx={classes.fields(isMobile)}>
              <Grid size={12}>
                <FormikTextField name="orderNumber" label="Order Number" variant="filled" slotProps={{ htmlInput: { inputMode: 'numeric' } }} />
              </Grid>
              <Grid size={12}>
                <Button type="button" variant="text" endIcon={<ChevronRight />} sx={classes.helpLink} onClick={() => setIsOrderHelpOpen(true)}>
                  Help me find the Order Number
                </Button>
              </Grid>
              <Grid size={12}>
                <FormikTextField name="lastName" label="Last Name" variant="filled" />
              </Grid>
              <Grid size={12}>
                <FormikTextField name="zipCode" label="Zip Code" variant="filled" slotProps={{ htmlInput: { inputMode: 'numeric' } }} />
              </Grid>
            </Grid>

            <Grid container={true} sx={classes.submitContainer}>
              <Button type="submit" variant="contained" size="large" disableElevation disabled={!isValid || isSubmitting}>
                Continue
              </Button>
            </Grid>
          </Grid>
          <FindOrderNumberDrawer open={isOrderHelpOpen} onClose={() => setIsOrderHelpOpen(false)} />
        </Grid>
      )}
    </Formik>
  )
}

export default HSPRegistration
